export const FALLING_PIECE_COUNT = 24;

function pieceStyle(index: number) {
  return {
    left: `${(index * 37 + 7) % 93}%`,
    animationDelay: `${-(index % 7) * 0.32}s`,
    animationDuration: `${3.5 + (index % 5) * 0.22}s`,
  };
}

export function FallingPieces() {
  return (
    <div className="falling-pieces" aria-hidden="true">
      {Array.from({ length: FALLING_PIECE_COUNT }, (_, index) => (
        <i key={index} className="falling-piece" style={pieceStyle(index)} />
      ))}
    </div>
  );
}
